import React from "react";

const ChevronLeft = props => {
  return (
    <svg width="18" height="18" {...props}>
      <path
        fill="#9B9B9B"
        fillRule="nonzero"
        d="M11.8 14.75L6.95 9.42l4.79-4.93a.9.9 0 0 0 0-1.24.81.81 0 0 0-1.18 0l-5.2 5.49a1 1 0 0 0 0 1.37l5.27 5.63c.3.32.78.35 1.12.07a.74.74 0 0 0 .07-1.06z"
      />
    </svg>
  );
};

export default ChevronLeft;
